import React from 'react';
import styled from '@emotion/styled';
import { colors, dimensions } from '@styles';

const InputRadio = styled.div`
  margin-right: 40px;

  input[type='checkbox'] {
    display: none;
  }

  label {
    color: ${colors.white};
    font-size: ${dimensions.fontSize.regular}px;
    font-weight: 300;
    position: relative;
    padding-left: 25px;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      border: 1px solid #c9c9c9;
      background-color: #555555;
    }
  }

  input[type='checkbox']:checked + label {
    &:before {
      border: 1px solid #009944;
    }

    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 3px;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #009944;
    }
  }

  &.inActive {
    pointer-events: none;
    opacity: 0.25;
  }

  &.no-margin {
    margin: 0;
  }

  &.color-white {
    label {
      &:before {
        border: 1px solid ${colors.white};
        background-color: ${colors.white};
      }
    }

    input[type='checkbox']:checked + label {
      &:before {
        border: 1px solid ${colors.white};
      }
      &:after {
        background-color: ${colors.black};
      }
    }
  }

  &.size-large {
    label {
      font-size: 14px;

      &:before {
        width: 20px;
        height: 20px;
      }
    }

    input[type='checkbox']:checked + label {
      &:after {
        left: 6px;
      }
    }
  }
`;

const RadioButtonLabel = styled.label`
  white-space: nowrap;
`;

interface InputRadioProps {
  idInput: string;
  nameInput: string;
  nameButton: string;
  onChangeRadio: Function;
  radioChecked: string;
  inActive: boolean;
  noMargin?: boolean;
  color?: 'white' | string;
  size?: 'large' | string;
}

export default ({
  idInput,
  nameInput,
  nameButton,
  onChangeRadio,
  radioChecked,
  inActive,
  noMargin,
  color,
  size
}: InputRadioProps) => (
  <InputRadio
    className={`
    ${inActive ? 'inActive' : ''}
    ${noMargin ? 'no-margin' : ''}
    ${color ? 'color-' + color : ''}
    ${size ? 'size-' + size : ''}
  `}
  >
    <input
      type="checkbox"
      id={idInput}
      name={nameInput}
      onChange={() => onChangeRadio(idInput)}
      checked={radioChecked === idInput ? true : false}
      disabled={inActive}
    />
    <RadioButtonLabel htmlFor={idInput}>{nameButton}</RadioButtonLabel>
  </InputRadio>
);
